<template>
  <div class="container mt-5">
    <h4 class="mb-4" style="color:#b03a45;">
      <i class="fas fa-user me-2 text-warning"></i>
      {{ $t("personalInfoEdit.title") }}
    </h4>

    <form @submit.prevent="handleSubmit" enctype="multipart/form-data">
      <div class="row">
        <!-- Gender -->
        <div class="col-md-6 mb-4">
          <div class="p-3 bg-white shadow-sm rounded">
            <label class="form-label fw-bold" style="color:#b03a45;">
              {{ $t("personalInfoEdit.fields.gender") }}
            </label>
            <select v-model="form.gender" class="form-select" required>
              <option disabled value="">
                {{ $t("personalInfoEdit.placeholders.select") }}
              </option>
              <option value="Male">{{ $t("personalInfoEdit.fields.male") }}</option>
              <option value="Female">{{ $t("personalInfoEdit.fields.female") }}</option>
            </select>
          </div>
        </div>

        <!-- Birth Date -->
        <div class="col-md-6 mb-4">
          <div class="p-3 bg-white shadow-sm rounded">
            <label class="form-label fw-bold" style="color:#b03a45;">
              {{ $t("personalInfoEdit.fields.dob") }}
            </label>
            <input
              type="date"
              v-model="form.date_of_birth"
              class="form-control"
              required
            />
          </div>
        </div>

        <!-- Arabic Name -->
        <div class="col-md-6 mb-4">
          <div class="p-3 bg-white shadow-sm rounded">
            <label class="form-label fw-bold" style="color:#b03a45;">
              {{ $t("personalInfoEdit.fields.arabicName") }}
            </label>
            <input
              type="text"
              v-model="form.arabic_name"
              class="form-control"
            />
          </div>
        </div>

        <!-- Place of Birth -->
        <div class="col-md-6 mb-4">
          <div class="p-3 bg-white shadow-sm rounded">
            <label class="form-label fw-bold" style="color:#b03a45;">
              {{ $t("personalInfoEdit.fields.placeOfBirth") }}
            </label>
            <input
              type="text"
              v-model="form.place_of_birth"
              class="form-control"
            />
          </div>
        </div>

        <!-- Place of Birth (Arabic) -->
        <div class="col-md-6 mb-4">
          <div class="p-3 bg-white shadow-sm rounded">
            <label class="form-label fw-bold" style="color:#b03a45;">
              {{ $t("personalInfoEdit.fields.placeOfBirthAr") }}
            </label>
            <input
              type="text"
              v-model="form.place_of_birth_ar"
              class="form-control"
            />
          </div>
        </div>

        <!-- Nationality -->
        <div class="col-md-6 mb-4">
          <div class="p-3 bg-white shadow-sm rounded">
            <label class="form-label fw-bold" style="color:#b03a45;">
              {{ $t("personalInfoEdit.fields.nationality") }}
            </label>
            <input
              type="text"
              v-model="form.nationality"
              class="form-control"
            />
          </div>
        </div>

        <!-- Address -->
        <div class="col-md-6 mb-4">
          <div class="p-3 bg-white shadow-sm rounded">
            <label class="form-label fw-bold" style="color:#b03a45;">
              {{ $t("personalInfoEdit.fields.address") }}
            </label>
            <input
              type="text"
              v-model="form.address"
              class="form-control"
            />
          </div>
        </div>

        <!-- Address (Arabic) -->
        <div class="col-md-6 mb-4">
          <div class="p-3 bg-white shadow-sm rounded">
            <label class="form-label fw-bold" style="color:#b03a45;">
              {{ $t("personalInfoEdit.fields.addressAr") }}
            </label>
            <input
              type="text"
              v-model="form.address_ar"
              class="form-control"
            />
          </div>
        </div>

        <!-- Phone Number -->
        <div class="col-md-6 mb-4">
          <div class="p-3 bg-white shadow-sm rounded">
            <label class="form-label fw-bold" style="color:#b03a45;">
              {{ $t("personalInfoEdit.fields.phone") }}
            </label>
            <input
              type="text"
              v-model="form.phone_number"
              class="form-control"
            />
          </div>
        </div>

        <!-- Marital Status -->
        <div class="col-md-6 mb-4">
          <div class="p-3 bg-white shadow-sm rounded">
            <label class="form-label fw-bold" style="color:#b03a45;">
              {{ $t("personalInfoEdit.fields.maritalStatus") }}
            </label>
            <select v-model="form.marital_status" class="form-select">
              <option disabled value="">
                {{ $t("personalInfoEdit.placeholders.select") }}
              </option>
              <option value="Single">{{ $t("personalInfoEdit.fields.single") }}</option>
              <option value="Married">{{ $t("personalInfoEdit.fields.married") }}</option>
              <option value="Divorced">{{ $t("personalInfoEdit.fields.divorced") }}</option>
              <option value="Widowed">{{ $t("personalInfoEdit.fields.widowed") }}</option>
            </select>
          </div>
        </div>

        <!-- Photo Upload -->
        <div class="col-md-6 mb-4">
          <div class="p-3 bg-white shadow-sm rounded">
            <label class="form-label fw-bold" style="color:#b03a45;">
              {{ $t("personalInfoEdit.fields.photo") }}
            </label>
            <input
              type="file"
              @change="onPhotoChange"
              class="form-control"
              accept="image/*"
            />
            <div v-if="photoPreview" class="mt-2">
              <img
                :src="photoPreview"
                alt="Photo preview"
                class="img-thumbnail"
                style="max-width: 150px;"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <div class="d-flex justify-content-end gap-3 mt-4">
        <!-- Back -->
        <button
          type="button"
          class="btn action-btn"
          @click="goBack"
          title="Back"
        >
          <i class="fas fa-arrow-left"></i>
        </button>

        <!-- Save -->
        <button
          type="submit"
          class="btn action-btn"
          title="Save"
        >
          <i class="fas fa-save"></i>
        </button>

        <!-- Next -->
        <button
          type="button"
          class="btn action-btn"
          @click="goNext"
          title="Next"
        >
          <i class="fas fa-arrow-right"></i>
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useToast } from 'vue-toastification'
import axios from '@/api'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const toast = useToast()

// === BASE URL API (ton .env) ===
// VUE_APP_API_URL = https://api.administration.cap.tn/api
const API_BASE = (process.env.VUE_APP_API_URL || '').replace(/\/+$/, '')
// Pour les fichiers, on enlève le "/api" final → https://api.administration.cap.tn
const FILE_BASE = API_BASE.replace(/\/api$/, '')

// Normalise TOUTES les URLs photo venant du back
const buildPhotoUrl = (photo) => {
  if (!photo) return null
  let url = String(photo).trim()

  // 1) Si c’est déjà une URL complète
  if (url.startsWith('http://') || url.startsWith('https://')) {
    url = url
      .replace('http://localhost:8000', FILE_BASE)
      .replace('https://localhost:8000', FILE_BASE)
    console.log('[photo] full url from API ->', url)
    return url
  }

  // 2) Chemin relatif, ex: "personal_photos/..." ou "storage/personal_photos/..."
  url = url.replace(/^\/+/, '')          // enlève les / en début
  url = url.replace(/^storage\//, '')    // enlève "storage/" s'il est déjà là

  const finalUrl = `${FILE_BASE}/storage/${url}`
  console.log('[photo] relative path from API ->', photo, '=>', finalUrl)
  return finalUrl
}

const userId = String(route.query.user_id || '')

const form = ref({
  user_id: userId,
  info_id: null,
  arabic_name: '',
  gender: '',
  date_of_birth: '',
  place_of_birth: '',
  place_of_birth_ar: '',
  nationality: '',
  address: '',
  address_ar: '',
  phone_number: '',
  marital_status: '',
  photo: null
})

const photoFile = ref(null)
const photoPreview = ref(null)

const fetchPersonalInfo = async () => {
  try {
    const { data } = await axios.get(`/employee/personal-information/${userId}`)
    if (data.data) {
      Object.assign(form.value, data.data, { user_id: userId })
      form.value.info_id = data.data.id

      if (data.data.date_of_birth) {
        const d = new Date(data.data.date_of_birth)
        form.value.date_of_birth = d.toISOString().split('T')[0]
      }

      if (data.data.photo) {
        photoPreview.value = buildPhotoUrl(data.data.photo)
      }
    }
  } catch (error) {
    console.error(error)
    toast.error(t('personalInfoEdit.messages.loadFailed'))
  }
}

const onPhotoChange = (e) => {
  const file = e.target.files[0]
  if (file && file.type.startsWith('image/')) {
    photoFile.value = file
    photoPreview.value = URL.createObjectURL(file)
  } else {
    photoFile.value = null
    photoPreview.value = null
    toast.error(t('personalInfoEdit.messages.invalidImage'))
  }
}

const handleSubmit = async () => {
  try {
    const payload = new FormData()

    payload.append('user_id', userId)
    payload.append('gender', form.value.gender || '')
    payload.append('date_of_birth', form.value.date_of_birth || '')
    payload.append('arabic_name', form.value.arabic_name || '')
    payload.append('place_of_birth', form.value.place_of_birth || '')
    payload.append('place_of_birth_ar', form.value.place_of_birth_ar || '')
    payload.append('nationality', form.value.nationality || '')
    payload.append('address', form.value.address || '')
    payload.append('address_ar', form.value.address_ar || '')
    payload.append('phone_number', form.value.phone_number || '')
    payload.append('marital_status', form.value.marital_status || '')

    if (photoFile.value) {
      payload.append('photo', photoFile.value)
    }

    const url = form.value.info_id
      ? `/employee/update-personal-info/${userId}`
      : `/employee/personal-information`

    // console.log('Payload:', [...payload])

    await axios.post(url, payload, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })

    toast.success(
      form.value.info_id
        ? t('personalInfoEdit.messages.updated')
        : t('personalInfoEdit.messages.created')
    )

    // On recharge pour avoir la vraie valeur du back, y compris la photo
    await fetchPersonalInfo()
  } catch (error) {
    console.error(error)
    toast.error(t('personalInfoEdit.messages.saveFailed'))
  }
}

const goBack = () =>
  router.push({ path: '/edit-employee', query: { user_id: userId } })

const goNext = () =>
  router.push({
    path: '/employee/information/professional/edit',
    query: { user_id: userId }
  })

onMounted(fetchPersonalInfo)
</script>





<style scoped>
.action-btn {
  background-color: #b03a45; /* même rouge que tes autres boutons */
  color: #ffffff;
  width: 50px;
  height: 45px;
  border-radius: 12px;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.action-btn-outline {
  background-color: transparent;
  color: #b03a45;
  width: 60px;
  height: 45px;
  border-radius: 12px;
  border: 1px solid #b03a45;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: transform 0.15s ease, box-shadow 0.15s ease,
    background-color 0.15s ease, color 0.15s ease;
}

.action-btn:hover,
.action-btn-outline:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(255, 67, 54, 0.25);
}
</style>
